if (!customElements.get('bundle-builder')) {
  class BundleBuilder extends HTMLElement {
    constructor() {
      super();
      this.mainPrice = parseInt(this.dataset.mainProductPrice || '0', 10);
      this.checkboxes = Array.from(this.querySelectorAll('input[type="checkbox"][data-price]'));
      this.totalEl = this.querySelector('[data-fbt-total]');
      this.addAllButton = this.querySelector('[data-fbt-add-all]');

      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', this.updateTotal.bind(this));
      });

      if (this.addAllButton) {
        this.addAllButton.addEventListener('click', this.addAllToCart.bind(this));
      }

      this.updateTotal();
    }

    formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme_money_format) {
        return window.Shopify.formatMoney(cents, window.theme_money_format);
      }
      return '£' + (cents / 100).toFixed(2);
    }

    updateTotal() {
      let total = this.mainPrice;
      this.checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          total += parseInt(checkbox.dataset.price || '0', 10);
        }
      });
      if (this.totalEl) {
        this.totalEl.textContent = this.formatMoney(total);
      }
    }

    async addAllToCart(event) {
      event.preventDefault();
      const items = [];
      const mainVariantId = this.dataset.mainProductId;
      if (mainVariantId) {
        items.push({ id: mainVariantId, quantity: 1 });
      }
      this.checkboxes.forEach((checkbox) => {
        if (checkbox.checked && checkbox.dataset.variantId) {
          items.push({ id: checkbox.dataset.variantId, quantity: 1 });
        }
      });

      if (!items.length) return;

      this.addAllButton.setAttribute('disabled', 'disabled');
      const originalText = this.addAllButton.textContent;
      this.addAllButton.textContent = '...';

      try {
        const response = await fetch(window.Shopify ? '/cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (response.ok) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.location.href = '/cart';
        } else {
          const data = await response.json().catch(() => ({}));
          console.error('Frequently bought together: add to cart failed', data);
          this.addAllButton.textContent = originalText;
          this.addAllButton.removeAttribute('disabled');
        }
      } catch (error) {
        console.error('Frequently bought together: add to cart error', error);
        this.addAllButton.textContent = originalText;
        this.addAllButton.removeAttribute('disabled');
      }
    }
  }

  customElements.define('bundle-builder', BundleBuilder);
}
